import React, { useEffect, useState } from "react";
import axios from "axios";
import { useOutletContext } from "react-router-dom";
import toastr from "../../../utils/toast";
import { useForm } from "react-hook-form";
import { set } from "date-fns";

function AddCompensation({ onClose, invoice_id, candidate_id, roleId }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();

  const [compList, setCompList] = useState([]);
  const [invoice, setInvoice] = useState([]);
  const [items, setItems] = useState([]);
  const [esops, setEsops] = useState([]);

  const { token, setGlobalLoading } = useOutletContext();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const fetch_comp = async () => {
    setGlobalLoading(true);
    try {
      const response = await axios.get(
        `${API_BASE_URL}/roles/get_compensation/${candidate_id}/${roleId}/${invoice_id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setCompList(response.data.compList);
      setInvoice(response.data.invoice);
      setItems(response.data.items);
      console.log(response.data);
    } catch (error) {
      console.log(error);
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };

  useEffect(() => {
    fetch_comp();
  }, [invoice_id, candidate_id, roleId]);

  useEffect(() => {
    if (compList.length > 0) {
      setValue("id", compList[0]?.id);
    } else {
      setValue("candidate_id", candidate_id);
      setValue("role_id", roleId);
      setValue("company_id", invoice[0]?.company_id);
      setValue("designation", invoice[0]?.role_name);
      setValue("currency_id", invoice[0]?.currency_id);
      setValue("conversion_rate", items[0]?.conversion_rate);
    }
    setValue(
      "total_ctc",
      compList[0]?.total_ctc || invoice[0]?.total_compensation || 0
    );
    setValue("fixed", compList[0]?.fixed || "");
    setValue("variable", compList[0]?.variable || "");
    setValue("esops", compList[0]?.esops || "");
    if (compList[0]?.esops === 1) {
      setEsops(1);
    }
    setValue("esops_val", compList[0]?.esops_val || 0);
    setValue("others", compList[0]?.others || 0);
  }, [compList, candidate_id, roleId, invoice, items, setValue]);

  const onSubmit = async (data) => {
    setGlobalLoading(true);
    const formData = new FormData();
    for (const key in data) {
      if (key === "userfile") {
        formData.append("userfile", data["userfile"][0]);
      } else {
        formData.append(key, data[key]);
      }
    }

    try {
      const response = await axios.post(
        `${API_BASE_URL}/roles/add_compensation`,
        formData, // ✅ send directly, not wrapped in {}
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        toastr.success(response.data.message);
        onClose();
      } else {
        toastr.error(response.data.message);
        onClose();
      }
    } catch (error) {
      console.log(error);
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };

  return (
    <div className="modal fade show d-block" tabIndex="-1">
      <div
        className="modal-dialog modal-dialog-centered"
        style={{ maxWidth: "500px" }}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              {compList.length > 0 ? "Update" : "Add"} Compensation Details
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>

          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="modal-body">
              <div className="row">
                {compList.length > 0 ? (
                  <>
                    <input id="id" type="hidden" {...register("id")} />
                  </>
                ) : (
                  <>
                    <input
                      id="candidate_id"
                      type="hidden"
                      {...register("candidate_id")}
                    />
                    <input
                      id="role_id"
                      type="hidden"
                      {...register("role_id")}
                    />
                    <input
                      id="company_id"
                      type="hidden"
                      {...register("company_id")}
                    />
                    <input
                      id="designation"
                      type="hidden"
                      {...register("designation")}
                    />
                    <input
                      id="currency_id"
                      type="hidden"
                      {...register("currency_id")}
                    />
                    <input
                      id="conversion_rate"
                      type="hidden"
                      {...register("conversion_rate")}
                    />
                  </>
                )}
                <div className="col-md-12">
                  <div className="row  mb-3">
                    <label className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-3 form-label">
                      Total CTC <span className="text-danger">*</span>
                    </label>
                    <div className="col-xxl-9 col-xl-9 col-lg-9 col-md-9 col-sm-9 input-group input-group-custom-comp">
                      <div className="input-group-text my-custom-input-group-text">
                        {invoice[0]?.currency_symbol}
                      </div>
                      <input
                        type="text"
                        className={`form-control ${
                          errors.total_ctc ? "is-invalid" : ""
                        }`}
                        placeholder="Total CTC"
                        {...register("total_ctc", {
                          required: true,
                          pattern: {
                            value: /^[0-9]*\.?[0-9]+$/,
                            message: "Only numbers are allowed without comma",
                          },
                        })}
                      />
                    </div>
                  </div>
                  <div className="row  mb-3">
                    <label className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-3 form-label">
                      Fixed Comp <span className="text-danger">*</span>
                    </label>
                    <div className="col-xxl-9 col-xl-9 col-lg-9 col-md-9 col-sm-9 input-group input-group-custom-comp">
                      <div className="input-group-text my-custom-input-group-text">
                        {invoice[0]?.currency_symbol}
                      </div>
                      <input
                        type="text"
                        className={`form-control ${
                          errors.fixed ? "is-invalid" : ""
                        }`}
                        placeholder="Total Fixed"
                        {...register("fixed", {
                          required: true,
                          pattern: {
                            value: /^[0-9]*\.?[0-9]+$/,
                            message: "Only numbers are allowed without comma",
                          },
                        })}
                      />
                    </div>
                  </div>
                  <div className="row  mb-3">
                    <label className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-3 form-label">
                      Variable Comp
                      <span className="text-danger">*</span>
                    </label>
                    <div className="col-xxl-9 col-xl-9 col-lg-9 col-md-9 col-sm-9 input-group input-group-custom-comp">
                      <div className="input-group-text my-custom-input-group-text">
                        {invoice[0]?.currency_symbol}
                      </div>
                      <input
                        type="text"
                        className={`form-control ${
                          errors.variable ? "is-invalid" : ""
                        }`}
                        placeholder="Total Variable"
                        {...register("variable", {
                          required: true,
                          pattern: {
                            value: /^[0-9]*\.?[0-9]+$/,
                            message: "Only numbers are allowed without comma",
                          },
                        })}
                      />
                    </div>
                  </div>
                  <div className="row  mb-3">
                    <label className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-3 form-label">
                      Esops
                      <span className="text-danger"> *</span>
                    </label>
                    <div className="col-xxl-9 col-xl-9 col-lg-9 col-md-9 col-sm-9">
                      <select
                        onChange={(e) => {
                          const value = parseInt(e.target.value, 10);
                          setEsops(value);
                        }}
                        className={`form-select ${
                          errors.esops ? "is-invalid" : ""
                        }`}
                        {...register("esops", {
                          required: true,
                          onChange: (e) => {
                            const value = parseInt(e.target.value, 10);
                            setEsops(value);
                          },
                        })}
                      >
                        <option value={""}>Select</option>
                        <option value={1}>Yes</option>
                        <option value={0}>No</option>
                      </select>
                    </div>
                  </div>
                  {esops == 1 && (
                    <div className="row  mb-3">
                      <label className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-3 form-label">
                        Esops Value
                        <span className="text-danger"> *</span>
                      </label>
                      <div
                        className={`col-xxl-9 col-xl-9 col-lg-9 col-md-9 col-sm-9`}
                      >
                        <input
                          type="text"
                          className={`form-control ${
                            errors.esops_val ? "is-invalid" : ""
                          }`}
                          {...register("esops_val", {
                            required: true,
                            pattern: {
                              value: /^[0-9]*\.?[0-9]+$/,
                              message: "Only numbers are allowed without comma",
                            },
                          })}
                          placeholder="Esops Value"
                        />
                      </div>
                    </div>
                  )}
                  <div className="row  mb-3">
                    <label className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-3 form-label">
                      Other Comp
                    </label>
                    <div
                      className={`col-xxl-9 col-xl-9 col-lg-9 col-md-9 col-sm-9`}
                    >
                      <input
                        className="form-control"
                        type="text"
                        {...register("others")}
                        placeholder="Other Comp Details"
                      />
                    </div>
                  </div>
                  <div className="row  mb-3">
                    <label className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-3 form-label">
                      Comp File
                    </label>
                    <div
                      className={`col-xxl-9 col-xl-9 col-lg-9 col-md-9 col-sm-9`}
                    >
                      <input
                        className="form-control"
                        type="file"
                        {...register("userfile")}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-success ms-2">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AddCompensation;
